import React from 'react';
import { Box, Text } from '@mantine/core';
import { Button, Alert } from '@xplatform/design-system';
import { IconRefresh } from '@tabler/icons-react';

interface ErrorScreenProps {
    message?: string;
    onRetry?: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
    message = "An error occurred",
    onRetry
}) => {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 'var(--mantine-spacing-md)',
                padding: '0 var(--mantine-spacing-sm)',
            }}
        >
            <Alert color="red" maw={400}>
                <Text size="sm">
                    {message}
                </Text>
            </Alert>

            {onRetry && (
                <Button
                    leftSection={<IconRefresh size={16} />}
                    onClick={onRetry}
                >
                    Retry
                </Button>
            )}
        </Box>
    );
};
